import { Output, Directive, ElementRef, EventEmitter, HostListener } from '@angular/core';

/**
 * Detects if a click has occured outside the element it is placed on
 *
 * Example usage:
 * <div [class.active]="dropdownActive" clickOutside (clickOutside)="closeDropdown()">...content</div>
 *
 * Clicking outside the div will call the closeDropdown() method to change state of the dropdownActive boolean
 */
@Directive({
    selector: '[clickOutside]'
})
export class ClickOutsideDirective {
    constructor(private _elementRef: ElementRef) {
    }

    @Output() clickOutside: EventEmitter<void> = new EventEmitter();

    @HostListener('document:mousedown', ['$event.target'])
    public onClick(targetElement: EventTarget) {
        const clickedInside = this._elementRef.nativeElement.contains(targetElement);
        if (!clickedInside) {
            this.clickOutside.emit();
        }
    }

}
